import * as React from "react"

function SvgArrowDown(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M18 9l-1.586-1.586-6.289 6.277V0h-2.25v13.691L1.586 7.414 0 9l9 9 9-9z"
        fill="#C51700"
      />
    </svg>
  )
}

export default SvgArrowDown

